import { createService } from '@bonanza-social/toolkit/api';
import { DailyRewardsResponseSchema } from './DailyRewardsService.schemas';

export default createService(
  {
    getDailyRewards: {
      method: 'GET',
      url: '/dailyRewards',
      responseSchema: DailyRewardsResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
